
















































































































import { Component, Prop } from "vue-property-decorator";
import { WorkshopModel, CompanyModel, AttendeeModel } from "@/core/models";
import { ConfirmDialogCpt } from "@/core/components";
import { WorkshopService, CompanyService } from "@/core/services";
import { RevStatusCpt, FollowUpStatusCpt } from "./status-badges";

import AppVue from "@/AppVue.vue";

@Component({
  components: {
    ConfirmDialogCpt,
    RevStatusCpt,
    FollowUpStatusCpt,
  },
})
export default class WorkshopDetailClientsGridCpt extends AppVue {
  @Prop() model: WorkshopModel;
  @Prop({ default: false }) loading: boolean;

  search = "";

  get companies() {
    return !this.model || !this.model.companies
      ? []
      : this.model.companies.filter(
          data => !this.search || data.name.toLowerCase().includes(this.search.toLowerCase()),
        );
  }

  private getAttendeeData(company: CompanyModel) {
    const data: AttendeeModel[] = [];
    if (company.attendee1Id) {
      data.push({
        attendeeName: company.attendee1Name,
        attendeeEmail: company.attendee1Email,
      });
    }

    if (company.attendee2Id) {
      data.push({
        attendeeName: company.attendee2Name,
        attendeeEmail: company.attendee2Email,
      });
    }

    return data;
  }
}
